import createCache, { EmotionCache } from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

// MUI v5 core components style themselves via Emotion, which does not
// auto-flip for RTL the way jss-rtl does for our @mui/styles (JSS) usage.
// This app defaults to Hebrew, so v5 components need this plugin to render
// correctly. `prefixer` must be included explicitly once stylisPlugins is
// overridden, or vendor-prefixing is lost.
const createEmotionCache = (): EmotionCache =>
  createCache({ key: "mui-rtl", stylisPlugins: [prefixer, rtlPlugin] });

export { createEmotionCache };
